import {
  CONTAINER_CODE_COLUMN,
  CONTAINER_TYPE_COLUMN,
  DEWAR_CODE_COLUMN,
  LOCATION_COLUMN,
  NAME_COLUMN,
  PROTEIN_ACRONYM_CSV_COLUMN,
} from './CSVImport'

const VALID_NAME = /^[\w-]+$/g

export const validateCell = (line, cellIndex, proteinAcronyms, names, locations) => {
  const text = line[cellIndex]
  if (cellIndex === LOCATION_COLUMN) {
    return { text, error: !validateLocation(locations, text, line[CONTAINER_CODE_COLUMN]) }
  } else if (cellIndex === CONTAINER_TYPE_COLUMN) {
    return { text, error: !validateContainerType(text) }
  } else if (cellIndex === PROTEIN_ACRONYM_CSV_COLUMN) {
    return { text, error: !validateProteinAcronym(text, proteinAcronyms) }
  } else if (cellIndex === NAME_COLUMN) {
    return { text, error: !validateName(`${line[DEWAR_CODE_COLUMN]}-${text}`, names) }
  }
  return { text, valid: true }
}

const validateLocation = (locations, location, containerName) => {
  if (parseInt(location) < 1 || parseInt(location) > 16) {
    return false
  }
  return locations.filter(l => l === `${containerName}-${location}`).length === 1
}

const validateContainerType = type => type.toUpperCase() === 'UNIPUCK'
const validateProteinAcronym = (text, acronyms) => acronyms.includes(text)
const validateName = (text, names) => {
  if (!text.match(VALID_NAME)) {
    return false
  }
  return names.filter(n => n === text).length === 1
}
